export const LOCAL_STORAGE_KEYS = {
  InitialRegion: 'initialRegion',
  RecentlyViewedItems: 'recentlyViewedItems',
  TermsAndConditionsAccepted: 'termsAndConditionsAccepted',
  CookiePolicyAccepted: 'cookiePolicyAccepted'
}
